import React from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { SubmitButton } from 'Components/Fields/Buttons';
import { compareToPassword, passStrength, password, required } from 'Utils/FormValidation';
import { useForm } from 'Hooks/useForm';
import { FormField } from 'Components/HookFormFields/FormField';
import 'Components/HookFormFields/PasswordField.css';

const ResetPasswordForm = ({ onFormSubmit }) => {
  const formName = 'resetPasswordForm';

  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
  });

  return (
    <form onSubmit={(event) => handleSubmit(event)} className={formName}>
      <FormField
        name="newPass"
        label="New Password (6 character min)"
        component="PasswordField"
        validate={[required, password]}
        warn={passStrength}
        autofocus
        {...formFieldProps}
      />
      <FormField
        name="confirmPass"
        label="Confirm New Password"
        component="PasswordField"
        validate={[required, password, compareToPassword]}
        autoValidate={true}
        {...formFieldProps}
      />
      <SubmitError error={formError} formName={formName} />
      <SubmitButton text="Reset Password" isDisabled={submitting || submitDisabled} />
    </form>
  );
};

export default ResetPasswordForm;
